import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const UPDATE_QUERY = print(gql`
  mutation CreateCategory($data: UpdateCategoryInput!) {
    updateCategory(data: $data) {
      id
    }
  }
`);

export interface UpdateGql {
  updateCategory: {
    id: number;
  };
}
